import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GroupsList } from '@core/entities';
import { FilterQuery } from '@core/types';

@Injectable({
  providedIn: 'root',
})
export class GroupsService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;

  find(queryParams?: FilterQuery): Observable<GroupsList> {
    return this._http.get<any>(`${this._apiUrl}/getAllApprovedGroups/`, { params: queryParams });
  }

  get(groupId: number): Observable<GroupsList> {
    return this._http.get<any>(`${this._apiUrl}/getAllApprovedGroups/?groupId=${groupId}`);
  }

  delete(groupId: number): Observable<any> {
    return this._http.delete<any>(`${this._apiUrl}/deleteGroup/${groupId}`);
  }

  leave(groupId: number, userId: number): Observable<any> {
    return this._http.delete<any>(`${this._apiUrl}/leaveGroup/user/${userId}/group_id/${groupId}`);
  }

  join(groupId: number, userId: number): Observable<any> {
    return this._http.post<any>(`${this._apiUrl}/joinGroup/user_id/${userId}/group_id/${groupId}`, {});
  }

  create(formData: FormData): Observable<any> {
    return this._http.post<any>(`${this._apiUrl}/createGroup`, formData);
  }

  update(groupId: number, formData: FormData): Observable<any> {
    return this._http.put<any>(`${this._apiUrl}/updateGroup/${groupId}`, formData);
  }

  /**
   * Get all approved groups with group id and name for navigation
   * @returns {Observable<{id:number;name:string}>}
   */
  getAll(): Observable<any> {
    return this._http.get<{ id: number; name: string }>(`${this._apiUrl}/getAllApprovedGroupsForMobileNavigation/`);
  }

  getApprovedGroupUsers(groupId: number): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/approvedGroupUsers/group/${groupId}`);
  }

  getGroupsByUserId(userId: number): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/web/get-groups-by-user-id/${userId}`);
  }

  getGroupParticipants(groupId: number): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/getGroupParticipants/group/${groupId}`);
  }
}
